var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 5.25008H10.7916L7.58325 2.04175V5.25008ZM3.49992 1.16675H8.16659L11.6666 4.66675V11.6667C11.6666 11.9762 11.5437 12.2729 11.3249 12.4917C11.1061 12.7105 10.8093 12.8334 10.4999 12.8334H3.49992C3.1905 12.8334 2.89375 12.7105 2.67496 12.4917C2.45617 12.2729 2.33325 11.9762 2.33325 11.6667V2.33341C2.33325 1.68591 2.85242 1.16675 3.49992 1.16675ZM8.74992 10.5001V9.33342H3.49992V10.5001H8.74992ZM10.4999 8.16675V7.00008H3.49992V8.16675H10.4999Z",
    fill: "#42A5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b32692d0c694c0601618ba3cebc26654.svg";
export { ForwardRef as ReactComponent };